<ion-content>
  <app-global-page-header [title]="'P0003600.ensavoirplus' | translate">
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <p class="my-2 mb-4 color-medium">
      {{ 'P0003600.filtrationModePlusIntro' | translate }}
    </p>

    <div>
      <div class="h4 mb-3">
        {{ 'P0003600.filtrationModePlusMode234' | translate }}
      </div>
      <p class="my-2 mb-4 color-medium">
        {{ 'P0003600.filtrationModePlusMode234Text' | translate }}
      </p>

      <table
        class="table table-bordered"
        style="width: 100%; border-width: 2px !important"
      >
        <tr>
          <th class="fw-normal p-1 color-medium">
            {{ 'P0003600.filtrationModePlusDureeFiltration' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Usine1' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Usine2' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Usine3' | translate }}
          </th>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Janvier' | translate }}
          </td>
          <td class="p-1 color-medium">1h</td>
          <td class="p-1 color-medium">2h</td>
          <td class="p-1 color-medium">3h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Fevrier' | translate }}
          </td>
          <td class="p-1 color-medium">1h</td>
          <td class="p-1 color-medium">2h</td>
          <td class="p-1 color-medium">3h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Mars' | translate }}
          </td>
          <td class="p-1 color-medium">1h</td>
          <td class="p-1 color-medium">2h</td>
          <td class="p-1 color-medium">3h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Avril' | translate }}
          </td>
          <td class="p-1 color-medium">2h</td>
          <td class="p-1 color-medium">3h</td>
          <td class="p-1 color-medium">5h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Mai' | translate }}
          </td>
          <td class="p-1 color-medium">3h</td>
          <td class="p-1 color-medium">4h</td>
          <td class="p-1 color-medium">6h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Juin' | translate }}
          </td>
          <td class="p-1 color-medium">7h</td>
          <td class="p-1 color-medium">8h</td>
          <td class="p-1 color-medium">10h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Juillet' | translate }}
          </td>
          <td class="p-1 color-medium">8h</td>
          <td class="p-1 color-medium">9h</td>
          <td class="p-1 color-medium">12h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Aout' | translate }}
          </td>
          <td class="p-1 color-medium">8h</td>
          <td class="p-1 color-medium">9h</td>
          <td class="p-1 color-medium">12h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Septembre' | translate }}
          </td>
          <td class="p-1 color-medium">8h</td>
          <td class="p-1 color-medium">9h</td>
          <td class="p-1 color-medium">12h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Octobre' | translate }}
          </td>
          <td class="p-1 color-medium">7h</td>
          <td class="p-1 color-medium">8h</td>
          <td class="p-1 color-medium">11h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Novembre' | translate }}
          </td>
          <td class="p-1 color-medium">3h</td>
          <td class="p-1 color-medium">4h</td>
          <td class="p-1 color-medium">7h</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003600.filtrationModePlusMode234Decembre' | translate }}
          </td>
          <td class="p-1 color-medium">1h</td>
          <td class="p-1 color-medium">2h</td>
          <td class="p-1 color-medium">4h</td>
        </tr>
      </table>

      <p class="my-2 mb-4 color-medium">
        {{ 'P0003600.filtrationModePlusMode234TextSuite' | translate }}
      </p>
    </div>

    <div>
      <div class="h4 mb-3">
        {{ 'P0003600.filtrationModePlusMode5' | translate }}
      </div>
      <p class="my-2 mb-4 color-medium">
        {{ 'P0003600.filtrationModePlusMode5Text' | translate }}
      </p>
    </div>

    <div>
      <div class="h4 mb-3">
        {{ 'P0003600.filtrationModePlusMode6' | translate }}
      </div>
      <p class="my-2 mb-4 color-medium">
        {{ 'P0003600.filtrationModePlusMode6Text' | translate }}
      </p>
    </div>

    <div>
      <div class="h4 mb-3">
        {{ 'P0003600.filtrationModePlusMode1' | translate }}
      </div>
      <p class="my-2 mb-4 color-medium">
        {{ 'P0003600.filtrationModePlusMode1Text' | translate }}
      </p>
    </div>

    <div>
      <div class="h4 mb-3">
        {{ 'P0003600.filtrationModePlusMode0' | translate }}
      </div>
      <p class="my-2 mb-4 color-medium">
        {{ 'P0003600.filtrationModePlusMode0Text' | translate }}
      </p>
    </div>
  </div>
</ion-content>
